import { defineCopy } from '@/i18n'

// Each section is a heading plus blocks, where a block is either { p: text } or { ul: [items] }.
// The English version is a translation for readers; have it reviewed before relying on it legally.
export default defineCopy('privacy', {
  id: {
    title: 'Kebijakan Privasi',
    intro: 'Kami berkomitmen untuk melindungi privasi anda. Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi yang anda berikan saat menggunakan aplikasi kami.',
    sections: [
      {
        title: 'Informasi yang Dikumpulkan',
        blocks: [
          { p: 'Kami mengumpulkan informasi pribadi yang anda berikan saat registrasi awal, seperti:' },
          { ul: ['Nama lengkap', 'Alamat email', 'Nomor telepon', 'Informasi lain yang relevan dengan layanan kami'] },
          { p: 'Kami juga dapat mengumpulkan data anonim yang tidak dapat digunakan untuk mengidentifikasi anda secara pribadi. Data ini digunakan untuk analisis statistik dan meningkatkan layanan kami.' },
        ],
      },
      {
        title: 'Penggunaan Informasi',
        blocks: [
          { p: 'Informasi yang kami kumpulkan digunakan untuk:' },
          {
            ul: [
              'Mengelola akun anda',
              'Memberikan dukungan dan layanan pelanggan',
              'Mengirimkan pembaruan penting terkait aplikasi',
              'Meningkatkan fitur dan layanan aplikasi',
              'Melakukan analisis statistik menggunakan data anonim untuk meningkatkan kinerja dan pengalaman pengguna',
              'Memantau dan meningkatkan layanan kami',
            ],
          },
        ],
      },
      {
        title: 'Keamanan Informasi',
        blocks: [
          { p: 'Kami menerapkan langkah-langkah keamanan yang sesuai untuk melindungi data pribadi anda. Namun, tidak ada metode transmisi data melalui internet yang 100% aman, dan kami tidak dapat menjamin keamanan absolut.' },
        ],
      },
      {
        title: 'Berbagi Informasi',
        blocks: [
          { p: 'Kami tidak akan membagikan informasi pribadi anda kepada pihak ketiga kecuali jika diwajibkan oleh hukum atau dengan persetujuan anda.' },
        ],
      },
      {
        title: 'Perubahan Kebijakan Privasi',
        blocks: [
          { p: 'Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Setiap perubahan akan diumumkan di aplikasi.' },
        ],
      },
    ],
    contact: 'Jika anda memiliki pertanyaan terkait kebijakan privasi ini, silakan hubungi kami di',
  },
  en: {
    title: 'Privacy Policy',
    intro: 'We are committed to protecting your privacy. This privacy policy explains how we collect, use, and protect the personal information you provide when using our application.',
    sections: [
      {
        title: 'Information We Collect',
        blocks: [
          { p: 'We collect the personal information you provide when you first register, such as:' },
          { ul: ['Full name', 'Email address', 'Phone number', 'Other information relevant to our services'] },
          { p: 'We may also collect anonymous data that cannot be used to identify you personally. This data is used for statistical analysis and to improve our services.' },
        ],
      },
      {
        title: 'How We Use Information',
        blocks: [
          { p: 'The information we collect is used to:' },
          {
            ul: [
              'Manage your account',
              'Provide support and customer service',
              'Send important updates about the application',
              'Improve the features and services of the application',
              'Perform statistical analysis on anonymous data to improve performance and user experience',
              'Monitor and improve our services',
            ],
          },
        ],
      },
      {
        title: 'Information Security',
        blocks: [
          { p: 'We apply appropriate security measures to protect your personal data. However, no method of transmitting data over the internet is 100% secure, and we cannot guarantee absolute security.' },
        ],
      },
      {
        title: 'Sharing Information',
        blocks: [
          { p: 'We will not share your personal information with third parties unless required by law or with your consent.' },
        ],
      },
      {
        title: 'Changes to This Privacy Policy',
        blocks: [
          { p: 'We may update this privacy policy from time to time. Any changes will be announced in the application.' },
        ],
      },
    ],
    contact: 'If you have any questions about this privacy policy, please contact us at',
  },
})
